/**
 * @generated SignedSource<<8ce827624d9771c98140f757daa14c25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskHintStatusEnum = "published" | "saved" | "%future added value";
export type TaskSubmitFeedbackStatusEnum = "published" | "saved" | "%future added value";
export type TaskHintFeedbackSaveInput = {
  aiCreationModified: boolean;
  correct?: EditorInput | null;
  general?: EditorInput | null;
  hint?: EditorInput | null;
  hintAiSuggestion?: string | null;
  incorrect?: EditorInput | null;
  isMeaningless: boolean;
  isSimpleModified: boolean;
  special?: EditorInput | null;
  specialAnswer?: string | null;
  task: string;
};
export type EditorInput = {
  text: string;
  textHtml?: string | null;
};
export type TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation$variables = {
  input: TaskHintFeedbackSaveInput;
};
export type TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation$data = {
  readonly taskHintFeedbackSave: {
    readonly hint: {
      readonly id: string;
      readonly status: TaskHintStatusEnum;
    } | null;
    readonly id: string;
    readonly submitFeedback: {
      readonly id: string;
      readonly status: TaskSubmitFeedbackStatusEnum;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"TaskActionsMutationButtonStack_task" | "TaskHintFeedbackSaveDialog_task">;
  };
};
export type TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation = {
  response: TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation$data;
  variables: TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answer",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  (v6/*: any*/)
],
v9 = [
  (v2/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "originalTask",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "order": "DESC"
    }
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitATitle",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitBTitle",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unitCTitle",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": (v12/*: any*/),
  "concreteType": "UnitD",
  "kind": "LinkedField",
  "name": "unitDs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": "unitDs(order:{\"order\":\"DESC\"})"
},
v18 = [
  (v2/*: any*/),
  (v11/*: any*/),
  (v17/*: any*/)
],
v19 = [
  (v2/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskHintFeedbackSave",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskHintFeedbackSaveDialog_task"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskHint",
            "kind": "LinkedField",
            "name": "hint",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskSubmitFeedback",
            "kind": "LinkedField",
            "name": "submitFeedback",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskActionsMutationButtonStack_task"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskHintFeedbackSave",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskProblem",
            "kind": "LinkedField",
            "name": "problem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "problemType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "problem",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "solution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creationType",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answerType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answerChoiceCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Unit",
            "kind": "LinkedField",
            "name": "unit",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schoolType",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskHint",
            "kind": "LinkedField",
            "name": "hint",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskSubmitFeedback",
            "kind": "LinkedField",
            "name": "submitFeedback",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "specialAnswer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "special",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "general",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Scrap",
            "kind": "LinkedField",
            "name": "scrap",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ScrapSource",
                "kind": "LinkedField",
                "name": "scrapSource",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assigned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "aiFile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "objectUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProblemGenerator",
            "kind": "LinkedField",
            "name": "problemGenerator",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneratedProblem",
            "kind": "LinkedField",
            "name": "generatedProblem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProblemGenerator",
                "kind": "LinkedField",
                "name": "problemGenerator",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMigrated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "migrationDifficultyNeedsReview",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DerivedTaskGroup",
            "kind": "LinkedField",
            "name": "derivedTaskGroups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "migrationPair",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "labelingCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabeling",
            "kind": "LinkedField",
            "name": "firstLabeling",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabeling",
            "kind": "LinkedField",
            "name": "secondLabeling",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabeling",
            "kind": "LinkedField",
            "name": "finalLabeling",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "UnitD",
            "kind": "LinkedField",
            "name": "publishedUnitDs",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "nextUnitD",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "previousUnitD",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "publishedUnitDs(order:{\"order\":\"DESC\"})"
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiDifficulty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TypingAutomationScript",
            "kind": "LinkedField",
            "name": "typingAutomationScript",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskProblemSolveInfo",
            "kind": "LinkedField",
            "name": "problemSolveInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "correctRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskSpecialAnswer",
                "kind": "LinkedField",
                "name": "specialAnswers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rank",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "percentage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "year",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inMigrationPairSync",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f6c533d7c29fb9a017f711e1cd3f918a",
    "id": null,
    "metadata": {},
    "name": "TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation",
    "operationKind": "mutation",
    "text": "mutation TaskHintFeedbackSaveDialog_taskHintFeedbackSaveMutation(\n  $input: TaskHintFeedbackSaveInput!\n) {\n  taskHintFeedbackSave(input: $input) {\n    id\n    ...TaskHintFeedbackSaveDialog_task\n    hint {\n      id\n      status\n    }\n    submitFeedback {\n      id\n      status\n    }\n    ...TaskActionsMutationButtonStack_task\n  }\n}\n\nfragment TaskActionsMutationButtonStack_task on Task {\n  id\n  actions\n  assignedTo {\n    id\n  }\n  ...TaskHintFeedbackPublishDialog_task\n  ...TaskMigrateDialog_task\n  ...TaskMigrationPairSyncDialog_task\n  difficulty\n  publishedUnitDs(order: {order: DESC}) {\n    id\n  }\n  finalLabeling {\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n    }\n    id\n  }\n  inMigrationPairSync\n  problem {\n    id\n    problem\n    solution\n  }\n}\n\nfragment TaskDescriptionList_task on Task {\n  id\n  title\n  problem {\n    id\n    problemType\n    creationType\n    answer\n    answerType\n    answerChoiceCount\n  }\n  scrap {\n    id\n    scrapSource {\n      id\n      title\n    }\n  }\n  ...TaskStatusLabel_task\n  assignedTo {\n    id\n    ...UserAvatarText_user\n  }\n  assigned\n  aiFile {\n    id\n    objectUrl\n  }\n  problemGenerator {\n    id\n  }\n  generatedProblem {\n    id\n    problemGenerator {\n      id\n      originalTask {\n        id\n      }\n    }\n  }\n  originalTask {\n    id\n  }\n  isMigrated\n  migrationDifficultyNeedsReview\n  derivedTaskGroups {\n    kind\n    count\n  }\n  migrationPair {\n    id\n  }\n  labelingCount\n  firstLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  secondLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  finalLabeling {\n    id\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n      unitATitle\n      unitBTitle\n      unitCTitle\n      description\n    }\n  }\n  unitDs(order: {order: DESC}) {\n    id\n    unitATitle\n    unitBTitle\n    unitCTitle\n    description\n  }\n  publishedUnitDs(order: {order: DESC}) {\n    id\n    unitATitle\n    unitBTitle\n    unitCTitle\n    description\n  }\n  difficulty\n  aiDifficulty\n  typingAutomationScript {\n    id\n    title\n  }\n}\n\nfragment TaskHintFeedbackPublishDialog_task on Task {\n  id\n  hint {\n    id\n    text\n  }\n  submitFeedback {\n    id\n    specialAnswer\n    special\n    general\n  }\n}\n\nfragment TaskHintFeedbackSaveDialog_task on Task {\n  id\n  sequence\n  title\n  problem {\n    id\n    problemType\n    problem\n    solution\n  }\n  unit {\n    schoolType\n    id\n  }\n  hint {\n    id\n    text\n  }\n  submitFeedback {\n    id\n    specialAnswer\n    special\n    general\n  }\n  ...TaskDescriptionList_task\n  publishedUnitDs(order: {order: DESC}) {\n    id\n    ...UnitDItem_unitD\n  }\n  problemSolveInfo {\n    ...TaskProblemSolveInfoDescriptionList_taskProblemSolveInfo\n    specialAnswers {\n      rank\n      answer\n      percentage\n    }\n  }\n}\n\nfragment TaskMigrateDialog_task on Task {\n  id\n  course {\n    id\n    year\n  }\n  publishedUnitDs(order: {order: DESC}) {\n    id\n    description\n    nextUnitD {\n      id\n      description\n    }\n    previousUnitD {\n      id\n      description\n    }\n  }\n}\n\nfragment TaskMigrationPairSyncDialog_task on Task {\n  id\n  isMigrated\n  migrationPair {\n    id\n    sequence\n  }\n  problem {\n    problem\n    solution\n    creationType\n    id\n  }\n  aiFile {\n    key\n    size\n    objectUrl\n    id\n  }\n}\n\nfragment TaskProblemSolveInfoDescriptionList_taskProblemSolveInfo on TaskProblemSolveInfo {\n  totalCount\n  correctRate\n}\n\nfragment TaskStatusLabel_task on Task {\n  status\n}\n\nfragment UnitDItem_unitD on UnitD {\n  id\n  unitATitle\n  unitBTitle\n  unitCTitle\n  description\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "57779d97cdfd9f82a7abbbe6ca9cb8b5";

export default node;
